/*
  Force AU date formatting across the app.
  Call sites that render dates via ``toLocaleDateString()`` / ``toLocaleString()`` with no options get the app-wide
  DD-MMM-YYYY format (Melbourne time); calls with options but no locale (undefined or []) get en-AU instead of the
  browser's locale, so US-locale browsers never show month-first dates.
*/
import { LOCALE, TZ, fmtDate, fmtDateTime } from "./intl";

const _dateFormat = Date.prototype.toLocaleDateString;
const _dateTimeFormat = Date.prototype.toLocaleString;
const _timeFormat = Date.prototype.toLocaleTimeString;
const loc = (l) => (l == null || (Array.isArray(l) && !l.length) ? LOCALE : l);
const tz = (o) => (o.timeZone ? o : { ...o, timeZone: TZ });
// AU calls asking for a plain day + short/numeric month + year (no weekday) get the house DD-MMM-YYYY format
const house = (l, o) => loc(l) === LOCALE && o.day && o.month && o.year && o.month !== "long" && !o.weekday
  && (!o.timeZone || o.timeZone === TZ);

Date.prototype.toLocaleDateString = function (locales, options) {
  if (!options || house(locales, options)) return fmtDate(this);
  return _dateFormat.call(this, loc(locales), tz(options));
};

Date.prototype.toLocaleString = function (locales, options) {
  if (!options) return fmtDateTime(this);
  if (house(locales, options)) return options.hour ? fmtDateTime(this) : fmtDate(this);
  return _dateTimeFormat.call(this, loc(locales), tz(options));
};

Date.prototype.toLocaleTimeString = function (locales, options) {
  return _timeFormat.call(
    this,
    loc(locales),
    options ? tz(options) : { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: true },
  );
};
